// Canonical URL form for the whole site: leading slash, trailing slash, no
// duplicate slashes. Root stays "/".
//
// The trailing slash is the preferred form per the SEO audit — both variants
// answered 200, and the self-referencing canonical already pointed at the
// slashed one — so /x redirects to /x/ rather than the reverse.
//
// Files are the exception: a last segment carrying an extension (/llms.txt,
// /social.png) is a real file and must keep its exact form. Seo.js runs
// relative og:image paths through absoluteUrl, so without this a share image
// would be advertised as ".../social.png/".
//
// Written as CommonJS (unlike the rest of src/lib) so gatsby-node.js can
// require it as well — page paths and the hreflang/canonical tags have to be
// normalised by the exact same function or they drift apart again.

const normalizePath = path => {
  if (!path) return "/"

  const collapsed = `/${String(path)}`.replace(/\/{2,}/g, "/")
  if (collapsed === "/") return "/"

  const trimmed = collapsed.replace(/\/+$/, "")
  const lastSegment = trimmed.slice(trimmed.lastIndexOf("/") + 1)

  return lastSegment.includes(".") ? trimmed : `${trimmed}/`
}

const absoluteUrl = (siteUrl, path) =>
  `${String(siteUrl || "").replace(/\/+$/, "")}${normalizePath(path)}`

// Languages that exist in WordPress but are deliberately not built as pages.
// Shared so gatsby-node.js (page creation), HrefLangs.js (alternates) and
// getLlmsTxtContent.js (the llms.txt files) can never drift apart — a language
// present in one but not the other would make every page advertise an hreflang,
// or an llms.txt, for a URL that was never built.
const EXCLUDED_LANGUAGES = ["pcm", "yo"]

module.exports = { normalizePath, absoluteUrl, EXCLUDED_LANGUAGES }
